import type { ComponentType } from "react";
import { Pressable, StyleSheet } from "react-native";

import { HeartIcon } from "@/design/icons";
import { webControlHoverTransition } from "@/design/interactionMotion";
import { Text } from "@/design/Text";
import { palette, radius, space } from "@/design/tokens";

/**
 * The My Dancer action chip — heart, pink, one brand everywhere the feature
 * appears (home play chips, "Find my dancer" on performance pages).
 */
export function PinkChip({
  label,
  onPress,
  Icon = HeartIcon,
  fullWidth = false,
  size = "md"
}: {
  label: string;
  onPress: () => void;
  Icon?: ComponentType<{ size?: number; color?: string }>;
  fullWidth?: boolean;
  size?: "md" | "lg";
}) {
  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={label}
      onPress={onPress}
      style={({ pressed, hovered, focused }) => [
        styles.chip,
        size === "lg" && styles.lg,
        fullWidth && styles.fullWidth,
        (hovered || focused) && styles.chipLit,
        pressed && { opacity: 0.85 }
      ]}
    >
      <Icon size={size === "lg" ? 15 : 13} color={palette.pink} />
      <Text variant={size === "lg" ? "bodyStrong" : "smallStrong"} color={palette.pink}>
        {label}
      </Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  chip: {
    alignItems: "center",
    backgroundColor: "rgba(242, 160, 204, 0.12)",
    borderColor: "rgba(242, 160, 204, 0.3)",
    borderRadius: radius.pill,
    borderWidth: 1,
    flexDirection: "row",
    gap: space.sm,
    justifyContent: "center",
    minHeight: 40,
    paddingHorizontal: space.lg,
    paddingVertical: space.sm,
    ...webControlHoverTransition
  },
  lg: {
    minHeight: 52,
    paddingHorizontal: space.xl,
    paddingVertical: space.md
  },
  fullWidth: {
    alignSelf: "stretch"
  },
  chipLit: {
    backgroundColor: "rgba(242, 160, 204, 0.2)",
    borderColor: "rgba(242, 160, 204, 0.5)"
  }
});
